export default __webpack_public_path__ + "static/media/icon-delivered.9cd74725.png";